import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { useQuery } from '@apollo/client'
import { useParams } from 'react-router-dom'
import { CircularProgress, makeStyles } from '@material-ui/core'
import EmployeeSearchDetails from './EmployeeSearchDetails'
import PolicyDetailsView from 'src/components/Individual/MyPoliciesView/Views/PolicyDetailsView'
import { COLORS } from 'src/utils/Themes/colors'
import Modal from 'src/components/common/Modal'
import AddExistingPolicy from 'src/components/Individual/modals/AddExistingPolicy'
import { Employee_Search } from 'src/services/corporateService'
import { getClientId } from 'src/utils/commonMethods'
import GraphQlErrors from 'src/components/common/GraphQlErrors'

const ViewEmployee = () => {
  const classes = useStyles()
  const userInfo = useSelector((state) => state.userInfo)
  const params = useParams()
  const [employeeData, setEmployeeData] = useState({})
  const [employeeClaimsData, setEmployeeClaimsData] = useState({})
  const [policies, setPolicies] = useState([])

  const [isUploadPolicyOpen, setIsUploadPolicyOpen] = useState(false)

  const { clientId, clientType } = params

  const closeUploadPolicyModal = () => {
    setIsUploadPolicyOpen(false)
  }

  const openUploadPolicyModal = () => {
    setIsUploadPolicyOpen(true)
  }

  const { loading, error, data } = useQuery(
    Employee_Search(getClientId(params?.clientId, userInfo), params?.id),
    {
      errorPolicy: 'all',
      fetchPolicy: 'cache-and-network',
    }
  )
  useEffect(() => {
    if (data) {
      setEmployeeData(data?.employeeSearch ?? {})
      setEmployeeClaimsData(data?.employeeSearch ?? {})
      setPolicies(data?.employeeSearch?.policies ?? [])
    }
  }, [data])

  // const renderCard = (policy) => {
  //   return (
  //     <>
  //       <EmployeePolicyTileCard policyType={policy} />
  //     </>
  //   )
  // }
  if (loading)
    return (
      <div className='loadingContainer'>
        <CircularProgress />
      </div>
    )
  if (error) {
    return (
      <div>
        <GraphQlErrors error={error} />
      </div>
    )
  }
  return (
    <>
      {isUploadPolicyOpen ? (
        <Modal
          id='modal'
          bgcolor={'rgb(238, 238, 238)'}
          ordered={isUploadPolicyOpen}
          width={'60%'}
          left={'20%'}
          top={'14%'}
          // open={isUploadPolicyOpen}
          modelClosed={closeUploadPolicyModal}
        >
          <AddExistingPolicy
            closefunction={closeUploadPolicyModal}
            // clientId={companyName}
            clientId={clientId}
            clientType={clientType}
          />
        </Modal>
      ) : null}
      <div className={classes.root}>
        <EmployeeSearchDetails
          data={employeeData}
          claimsData={employeeClaimsData}
        />

        <div className={classes.policyContainer}>
          {policies?.length && (
            <PolicyDetailsView
              id='policyDetailsView'
              openUploadPolicy={openUploadPolicyModal}
              policyList={policies}
              clientId={params?.clientId}
              companyName={params?.clientId}
              clientType={params?.clientType}
              hideBanner={true}
              hideUploadPolicies={true}
              isEmployeeView={true}
              isEmployeeData={employeeData}
            />
          )}

          {/* {userInfo.userInfo.userData.policyHolderType !== 'CORPORATE_INDIVIDUAL' ? (*/}
          {/*  policies.map((policy) => {*/}
          {/*    return (*/}
          {/*      <span*/}
          {/*        key={`policyTileCard__${policy.insuranceMainName}__${policy.insuranceSubTypeName}`}*/}
          {/*      >*/}
          {/*        {renderCard(policy)}*/}
          {/*      </span>*/}
          {/*    );*/}
          {/*  })*/}
          {/* ) : (*/}
          {/*  <>*/}
          {/*    {policies.map((policy, index) => {*/}
          {/*      if (index < 3) {*/}
          {/*        return (*/}
          {/*          <span*/}
          {/*            key={`policyTileCard__${policy.insuranceMainName}__${policy.insuranceSubTypeName}`}*/}
          {/*          >*/}
          {/*            {renderCard(policy)}*/}
          {/*          </span>*/}
          {/*        );*/}
          {/*      }*/}
          {/*      return null;*/}
          {/*    })}*/}
          {/*    {policies.length > 3 && <p className={classes.policyHeading}>Personal Policies</p>}*/}
          {/*    {policies.map((policy, index) => {*/}
          {/*      if (index >= 3) {*/}
          {/*        return (*/}
          {/*          <span*/}
          {/*            key={`policyTileCard__${policy.insuranceMainName}__${policy.insuranceSubTypeName}`}*/}
          {/*          >*/}
          {/*            {renderCard(policy)}*/}
          {/*          </span>*/}
          {/*        );*/}
          {/*      }*/}
          {/*      return null;*/}
          {/*    })}*/}
          {/*  </>*/}
          {/* )} future development could be there*/}
        </div>
      </div>
    </>
  )
}

export default ViewEmployee

const useStyles = makeStyles({
  root: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    background: '#e5e5e5',
  },
  policyContainer: {
    margin: '10px',
    overflowX: 'auto',
    display: 'flex',
    position: 'relative',
    flexDirection: 'column',
    backgroundColor: COLORS.WHITE,
    borderRadius: '10px',
    padding: '20px',
  },
})
